<nb-layout>

  <nb-layout-header fixed *ngIf="userIsAuthenticated">
    <!-- Insert header here -->
    <!-- <app-header></app-header> -->
    <!-- <nb-icon style=" color: #797c83 ; font-size: xx-large; border-right: 1px solid #edf1f7;" icon="menu-2-outline" [options]="{ animation: { type: 'pulse' } }" (click)="toggleSidebar()"></nb-icon> -->
    <a (click)="toggleSidebar()" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a [routerLink]="['/']" style="text-decoration: none; margin-left: 12px" >
      <!-- <button nbButton status="success" size="tiny">Toggle</button> -->
      <img src="../../../assets/logo2.png" alt="" srcset="" style="width: 64px;height: 64px;">
      <!-- <h3 class="mat-headline">eGlu Console</h3> -->
    </a>
    <span class="header-spacer"></span>
    <nb-search *ngIf="userIsAuthenticated" type="rotate-layout">
      <div class="search">
        <p>search</p>
      </div>
    </nb-search>

    <nb-user *ngIf="userIsAuthenticated && userEmailId" name="{{userEmailId.split('@')[0]}}" title="{{userEmailId}}"
      [nbContextMenu]="items" nbContextMenuTag="my-context-menu">
    </nb-user>
    <!-- <button  nbButton *ngIf="userIsAuthenticated"><a mat-button routerLink="/" routerLinkActive="mat-accent">Home</a></button> -->
    <!-- <button  nbButton *ngIf="!userIsAuthenticated"><a mat-button routerLink="/login" routerLinkActive="mat-accent">Login</a></button> -->
    <!-- <button  nbButton *ngIf="!userIsAuthenticated"><a mat-button routerLink="/signup" routerLinkActive="mat-accent">Signup</a></button> -->
    <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
  </nb-layout-header>

  <nb-sidebar state="expanded" responsive *ngIf="userIsAuthenticated">
    <nb-menu [items]="menuItems"></nb-menu>
  </nb-sidebar>
  <nb-layout-column>
    <main>
      <router-outlet></router-outlet>
    </main>

  </nb-layout-column>


</nb-layout>
